/**
 * Display placeholder for empty profile/read values so blank fields
 * look intentional rather than broken.
 */
export const displayEmpty = (value?: string | null): string => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : '—';
};
